import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-section">
            <h4 className="footer-heading">Государственный университет управления</h4>
            <div className="footer-info">
              <p>
                <span className="footer-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                </span>
                Рязанский пр-т, д. 99, Москва, 109542
              </p>
              <p>
                <span className="footer-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                  </svg>
                </span>
                <a href="tel:+74953778914">+7 (495) 377-89-14</a>
              </p>
              <p>
                <span className="footer-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </span>
                <a href="mailto:inf@guu.ru">inf@guu.ru</a>
              </p>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Социальные сети</h4>
            <div className="footer-social">
              <a
                href="https://vk.com/glostate"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                title="ВКонтакте"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93v6.14C2 20.67 3.33 22 8.93 22h6.14c5.6 0 6.93-1.33 6.93-6.93V8.93C22 3.33 20.67 2 15.07 2zm3.08 14.27h-1.46c-.55 0-.72-.45-1.71-1.45-1.02-.98-1.45-1.11-1.7-1.11-.35 0-.45.1-.45.57v1.32c0 .41-.13.66-1.19.66-1.76 0-3.71-1.07-5.08-3.06C4.84 10.29 4.4 8.34 4.4 7.93c0-.25.1-.47.57-.47h1.46c.42 0 .59.19.75.64.82 2.37 2.2 4.45 2.76 4.45.21 0 .31-.1.31-.64V9.59c-.07-1.1-.64-1.19-.64-1.58 0-.19.16-.38.42-.38h2.3c.35 0 .48.19.48.62v2.56c0 .35.16.47.25.47.21 0 .39-.12.78-.51 1.21-1.35 2.07-3.43 2.07-3.43.12-.25.31-.47.73-.47h1.46c.44 0 .54.23.44.56-.18.87-1.93 3.29-1.93 3.29-.15.25-.21.37 0 .65.15.21.64.64 1.03 1.03.69.73 1.23 1.34 1.37 1.76.15.42-.07.64-.49.64z"/>
                </svg>
              </a>
              <a
                href="https://t.me/GUUmsk"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                title="Telegram"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
              </a>
              <a
                href="https://ok.ru/guuru"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                title="Одноклассники"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 3.5c1.934 0 3.5 1.566 3.5 3.5s-1.566 3.5-3.5 3.5-3.5-1.566-3.5-3.5 1.566-3.5 3.5-3.5zm0 2c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm4.243 6.707c-.392.392-.952.544-1.414.544-.392 0-.828-.092-1.172-.392-.716-.544-1.172-.544-1.657-.544-.485 0-.941 0-1.657.544-.344.3-.78.392-1.172.392-.462 0-1.022-.152-1.414-.544-.78-.78-.78-2.048 0-2.828.172-.172.344-.3.544-.392.716-.392 1.516-.544 2.3-.544h2.8c.784 0 1.584.152 2.3.544.2.092.372.22.544.392.78.78.78 2.048-.002 2.828zm-1.657 2.379l1.828 1.828c.392.392.392 1.024 0 1.414-.392.392-1.024.392-1.414 0l-1.828-1.828c-.392-.392-.392-1.024 0-1.414s1.024-.392 1.414 0zm-5.172 0c.392-.392 1.024-.392 1.414 0s.392 1.024 0 1.414l-1.828 1.828c-.392.392-1.024.392-1.414 0-.392-.392-.392-1.024 0-1.414l1.828-1.828z"/>
                </svg>
              </a>
              <a
                href="https://dzen.ru/guu"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                title="Дзен"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.41 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">О проекте</h4>
            <p className="footer-text">
              Индекс зрелости КВН — совместный проект ГУУ, Минобрнауки России
              и Клуба веселых и находчивых для мониторинга развития
              студенческого юмористического движения.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Государственный университет управления. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
